"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestClient = void 0;
const errors_1 = require("./errors");
class RequestClient {
    constructor(endpoint, options) {
        this.endpoint = endpoint;
        this.options = options;
    }
    request(method, path, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers();
            headers.set('Content-Type', 'application/json');
            headers.set('Accept', 'application/json');
            if (this.options.auth)
                headers.set('Authorization', this.options.auth);
            if (this.options.userAgent)
                headers.set('User-Agent', this.options.userAgent);
            const res = yield window.fetch(`${this.endpoint}/${this.options.version}/${path}`, {
                method,
                headers,
                body: body ? JSON.stringify(body) : null,
                credentials: this.options.auth ? 'include' : 'omit',
            });
            if (res.status === 204) {
                return {};
            }
            if (!res.ok) {
                let data;
                try {
                    data = yield res.json();
                }
                catch (_a) {
                    throw new errors_1.ResponseError(res);
                }
                throw new errors_1.APIError(data);
            }
            return res.json();
        });
    }
    get clientOptions() {
        return this.options;
    }
    get clientEndpoint() {
        return this.endpoint;
    }
    set clientEndpoint(v) {
        this.endpoint = v;
    }
}
exports.RequestClient = RequestClient;
